export default __webpack_public_path__ + "static/media/MailNew.edb57d2e.svg";